import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaClock } from "react-icons/fa";

const OpeningSoon = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-black text-white">
        <Modal.Title className="d-flex align-items-center gap-2">
          <FaClock color="#f59e0b" />
          Applications Opening Soon
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="bg-black text-white">
        <p className="text-secondary mb-0">
          Applications for WiSE Projects will open shortly. Details on project
          themes, application guidelines, and timelines will be shared soon.
          Stay tuned and be among the first to bring impactful ideas to life.
        </p>
      </Modal.Body>

      <Modal.Footer className="bg-black">
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OpeningSoon;
